// angular imports
import { 
    WritableSignal, 
    signal 
} from "@angular/core";

//local imports
import { IBreadcrumbItemModel, ListItemFactory } from "@app/shared";
import { AbstractProjectModel } from "@app/catalog-common";
import { ProjectDto, ProgramModel } from "@app/catalog";


export class ProjectModel extends AbstractProjectModel implements IBreadcrumbItemModel
{

    public thumbnailUrl: WritableSignal<string>;
    public program: WritableSignal<ProgramModel>;

    constructor()
    {                
        super();
        this.thumbnailUrl = signal<string>(null);    
        this.program = signal<ProgramModel>(null);
    }


    public static fromDto(dto: ProjectDto, isChecked: boolean = false)
    {
        let project = new ProjectModel();

        project.id = dto.id;
        project.name.set(dto.name);
        project.description.set(dto.description);
        project.thumbnailUrl.set(dto.thumbnailUrl);        
        project.isChecked.set(isChecked);
        project.isActive.set(dto.isActive);
        return project;
    }
    
    public toListItem = (selected: boolean = false) => 
        ListItemFactory.create<ProjectModel>(this.name, this.id, this, selected);
    

    public toListItem$ = (selected: WritableSignal<boolean>) =>
        ListItemFactory.create$<ProjectModel>(this.name, this.id, this, selected);    

}
